module.exports = __webpack_public_path__ + "imgesssyaa/svg/Layout-grid.ba14c20f.svg";